import React from "react";

type Props = {
  percent: number; // 0..100
  size?: number; // px
  color?: string;
  trackColor?: string;
  strokeWidth?: number;
  /** Replaces the default center label (e.g. compact quota meters). */
  children?: React.ReactNode;
  ariaLabel?: string;
};

const ProgressDonut = ({
  percent,
  size = 220,
  color = "#10B981",
  trackColor = "#E5E7EB",
  strokeWidth = 14,
  children,
  ariaLabel,
}: Props) => {
  const safe = Math.max(0, Math.min(100, percent));
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const dash = (safe / 100) * circumference;

  return (
    <div
      className="relative shrink-0"
      style={{ width: size, height: size }}
      role="img"
      aria-label={ariaLabel ?? `${safe}%`}
    >
      <svg width={size} height={size} className="-rotate-90" aria-hidden>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={trackColor}
          strokeWidth={strokeWidth}
          fill="transparent"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={`${dash} ${circumference - dash}`}
          strokeLinecap="round"
          fill="transparent"
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
        {children ?? (
          <>
            <div className="text-4xl font-semibold text-gray-800">{safe}%</div>
            <div className="text-gray-500 text-sm">Completion rate</div>
          </>
        )}
      </div>
    </div>
  );
};

export default ProgressDonut;
